import { WalletMovements } from "../modules/walletMovements";

export const WalletMovementsPage = () => {
  return <WalletMovements />;
};
